import { render, staticRenderFns } from "./TepViajeInternoInspeccion.vue?vue&type=template&id=12d28073"
import script from "./TepViajeInternoInspeccion.vue?vue&type=script&lang=js"
export * from "./TepViajeInternoInspeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports